<div class="body-top d-flex justify-content-between mb-15">
  <a [attr.href]="contentTemplateService.getImportExampleFileUrl()" class="left-text text-neutral-n9"><span class="icon-export me-2"></span>Download example
    file</a>
  <span class="right-text">Max Rows: {{ MAX_ROWS }}</span>
</div>

<div>
  <div class="form-group">
    <input-file (change)="onChangeImportFile($event)" [accept]="accept" [acceptExtensions]="acceptExtensions" [maxSize]="1048576" [maxFiles]="1"></input-file>
  </div>
  <div class="error-section">
    <div class="error-note" *ngIf="backendErrors?.errors.length">
      <span class="d-block">Unfortunately, not all the rows could be imported.</span>
      <span class="d-block"><strong>Imported Rows:</strong>{{ backendErrors.imported }}</span>
      <span class="d-block"><strong>Skipped Rows:</strong>{{ backendErrors.skipped }}</span>
    </div>
    <div class="error-note" *ngIf="validationErrors.length">
      <span class="d-block">Unfortunately, not all the content templates can be imported. There are some invalid rows
        present.</span>
      <span class="d-block"><strong>Total Rows:</strong>{{ rowsCount - 1 }}</span>
      <span class="d-block"><strong>Importable Rows:</strong>{{ items.length ? items.length : 0 }}</span>
    </div>
    <div class="error-table-wrapper">
      <table class="error-table mb-15" *ngIf="validationErrors.length">
        <thead>
          <tr>
            <th>Row</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let err of validationErrors">
            <td>{{ err.index + 1 }}</td>
            <td>{{ err.errors.join(", ") }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="error-table-wrapper">
      <table class="error-table mb-15" *ngIf="backendErrors?.errors.length">
        <thead>
          <tr>
            <th>Row</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let err of backendErrors?.errors">
            <td>{{ err.rowNumber + 1 }}</td>
            <td>{{ err.text }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button (click)="onCancelImport()" class="btn btn-outline-dark">Cancel</button>
      <button (click)="onSubmitImport()" [disabled]="!items.length || backendErrors?.errors.length > 0" class="btn btn-primary ms-15">
        Confirm <span *ngIf="showItemsLength(items)">({{ items.length ? items.length : 0 }})</span>
      </button>
    </div>
  </div>
</div>
